import request from '../utils/request.js'

// 测试接口
export function list() {
  return request({
    url: '/list',
    method: 'get',
  })
}

// 获取全局参数
export function global() {
  return request({
    url: '/website/api/global',
    method: 'post',
  })
}

// 机构概况
export function getMechanism(data) {
  return request({
    url: '/website/api/getMechanism',
    method: 'post',
	data:data
  })
}

// 工作动态
export function getNewsList(data) {
  return request({
    url: '/website/api/getNewsList',
    method: 'post',
	data:data
  })
}

// 通知
export function getNotifyList(data) {
  return request({
    url: '/website/api/getNotifyList',
    method: 'post',
	data:data
  })
}

// 风采
export function getTeamList() {
  return request({
    url: '/website/api/getTeamList',
    method: 'post',
  })
}

// 法律法规
export function getLawstatuteList() {
  return request({
    url: '/website/api/getLawstatuteList',
    method: 'post',
  })
}
// 办证指南
export function getGuideList() {
  return request({
    url: '/website/api/getGuideList',
    method: 'post',
  })
}
// 学术研究
export function getLearningList() {
  return request({
    url: '/website/api/getLearningList',
    method: 'post',
  })
}

// 材料
export function getMatterList() {
  return request({
    url: '/website/api/getMatterList',
    method: 'post',
  })
}


// 详情 
export function getDetails(data) {
  return request({
    url: '/website/api/getDetails',
    method: 'post',
	data:data
  })
}

